import { CONTACT } from "@/data/site";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "AutoRepair",
  "name": CONTACT.name,
  "image": "https://customer-assets.emergentagent.com/job_f27da418-ff2e-4da2-af9f-43e536aedb4c/artifacts/qzqldvf2_WhatsApp%20Image%202026-07-10%20at%2016.04.02.jpeg",
  "description": "Guincho 24 horas, guincho leve e pesado, transporte de máquinas, assistência rodoviária e auto socorro em Rondônia e Mato Grosso.",
  "telephone": CONTACT.phoneTel,
  "url": ORIGIN,
  "priceRange": "$$",
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
    "opens": "00:00",
    "closes": "23:59"
  },
  "areaServed": ["Rondônia", "Mato Grosso"],
  "sameAs": [CONTACT.instagram],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "reviewCount": "8",
    "bestRating": "5"
  }
});

export const serviceSchema = (name, description) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": name,
  "provider": { "@type": "AutoRepair", "name": CONTACT.name, "telephone": CONTACT.phoneTel },
  "areaServed": ["Rondônia", "Mato Grosso"],
  "description": description
});

export const faqSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": items.map((f) => ({
    "@type": "Question",
    "name": f.q,
    "acceptedAnswer": { "@type": "Answer", "text": f.a }
  }))
});

export const breadcrumbSchema = (trail) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": trail.map((t, i) => ({
    "@type": "ListItem",
    "position": i + 1,
    "name": t.name,
    "item": `${ORIGIN}${t.path}`
  }))
});
